import { Modal, useModals } from 'almanac-ui/Modal'
import Styles from './FontsModal.module.scss'
import { useFonts } from 'hooks/queries/workspaces/useFonts'
import { List } from './List'
import { LoadingState } from './LoadingState'
import { FontsUploadDropzone } from 'components/FontsUploadModal/FontsUploadDropzone'
import { UploadFontButton } from './UploadFontButton'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { Upload5 } from 'blaze-ui/icons'
import { TextStyle } from 'types'

interface FontsModalProps {
  textStyles?: TextStyle[]
}

const FontsModal = ({ textStyles }: FontsModalProps = {}) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { data, isLoading } = useFonts()
  const { closeModal } = useModals()

  const fonts = data?.fonts || []
  const actions = fonts.length > 0 && !isSystemRedesignEnabled ? <UploadFontButton /> : undefined

  return (
    <Modal.Root onPressOutside={closeModal}>
      <Modal.Header title="Your Fonts" actions={actions} />
      <Modal.Content className={Styles.content}>
        {isLoading && <LoadingState />}
        {!isLoading && fonts.length > 0 && (
          <>
            <List fonts={fonts} textStyles={textStyles} />
            {isSystemRedesignEnabled && (
              <div className={Styles.uploadButtonContainer}>
                <UploadFontButton frontIcon={Upload5} size="lg" variant="secondary" label="Upload Font" />
              </div>
            )}
          </>
        )}
        {!isLoading && fonts.length === 0 && <FontsUploadDropzone />}
      </Modal.Content>
    </Modal.Root>
  )
}

export { FontsModal }
